import React, { Children } from 'react';
import PageHeader from '../components/layout/PageHeader';
const PrivacyPolicy = () => {
  return <div className="min-h-screen bg-white" data-id="element-4363">
      <PageHeader title="Privacy Policy" description="Learn how we collect, use, and protect your information at Isonyin Grammar School." backgroundImage="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Privacy Policy',
      path: '/privacy-policy'
    }]} data-id="element-4364" />
      <div className="container mx-auto px-4 py-12" data-id="element-4365">
        <div className="max-w-4xl mx-auto bg-white p-6 md:p-8 rounded-lg shadow-md" data-id="element-4366">
          <div className="prose prose-blue max-w-none" data-id="element-4367">
            <h2 data-id="element-4368">Privacy Policy</h2>
            <p data-id="element-4369">
              <strong data-id="element-4370">Last Updated:</strong> January 1, 2025
            </p>
            <p data-id="element-4371">
              At Isonyin Grammar School, we are committed to protecting your
              privacy and ensuring the security of your personal information.
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you visit our website or interact
              with our school.
            </p>
            <h3 data-id="element-4372">Information We Collect</h3>
            <p data-id="element-4373">We may collect the following types of information:</p>
            <ul data-id="element-4374">
              <li data-id="element-4375">
                <strong data-id="element-4376">Personal Information:</strong> Name, address, email
                address, phone number, date of birth, gender, and other
                information you provide when applying for admission, registering
                for events, or contacting us.
              </li>
              <li data-id="element-4377">
                <strong data-id="element-4378">Academic Information:</strong> Educational records,
                transcripts, test scores, and academic performance data.
              </li>
              <li data-id="element-4379">
                <strong data-id="element-4380">Financial Information:</strong> Payment details, billing
                address, and financial aid information.
              </li>
              <li data-id="element-4381">
                <strong data-id="element-4382">Website Usage Information:</strong> IP address, browser
                type, operating system, referring URLs, and actions taken on our
                website.
              </li>
            </ul>
            <h3 data-id="element-4383">How We Use Your Information</h3>
            <p data-id="element-4384">
              We may use the information we collect for the following purposes:
            </p>
            <ul data-id="element-4385">
              <li data-id="element-4386">Process admissions applications and enrollment</li>
              <li data-id="element-4387">Communicate with students, parents, and guardians</li>
              <li data-id="element-4388">Administer educational programs and services</li>
              <li data-id="element-4389">Process payments and manage financial accounts</li>
              <li data-id="element-4390">Send newsletters, updates, and promotional materials</li>
              <li data-id="element-4391">Improve our website and services</li>
              <li data-id="element-4392">Comply with legal obligations</li>
              <li data-id="element-4393">Respond to inquiries and provide customer support</li>
            </ul>
            <h3 data-id="element-4394">Information Sharing and Disclosure</h3>
            <p data-id="element-4395">We may share your information with:</p>
            <ul data-id="element-4396">
              <li data-id="element-4397">
                School staff and faculty who need access to perform their duties
              </li>
              <li data-id="element-4398">Service providers who assist in our operations</li>
              <li data-id="element-4399">Educational partners and institutions</li>
              <li data-id="element-4400">Government authorities when required by law</li>
              <li data-id="element-4401">Accreditation bodies and educational associations</li>
            </ul>
            <p data-id="element-4402">
              We do not sell, trade, or otherwise transfer your personally
              identifiable information to outside parties for marketing
              purposes.
            </p>
            <h3 data-id="element-4403">Data Security</h3>
            <p data-id="element-4404">
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the Internet or electronic storage is 100%
              secure, and we cannot guarantee absolute security.
            </p>
            <h3 data-id="element-4405">Cookies and Tracking Technologies</h3>
            <p data-id="element-4406">
              Our website may use cookies and similar tracking technologies to
              enhance your experience, analyze usage patterns, and deliver
              personalized content. You can control cookies through your browser
              settings, but disabling cookies may limit your ability to use
              certain features of our website.
            </p>
            <h3 data-id="element-4407">Third-Party Links</h3>
            <p data-id="element-4408">
              Our website may contain links to third-party websites. We have no
              control over the content, privacy policies, or practices of these
              websites and are not responsible for their privacy practices. We
              encourage you to review the privacy policies of any third-party
              websites you visit.
            </p>
            <h3 data-id="element-4409">Children's Privacy</h3>
            <p data-id="element-4410">
              We are committed to protecting the privacy of children. Our
              website is not intended for children under 13 years of age, and we
              do not knowingly collect personal information from children under
              13 without verifiable parental consent. If we learn that we have
              collected personal information from a child under 13, we will
              promptly take steps to delete that information.
            </p>
            <h3 data-id="element-4411">Your Rights</h3>
            <p data-id="element-4412">
              Depending on your location, you may have certain rights regarding
              your personal information, including:
            </p>
            <ul data-id="element-4413">
              <li data-id="element-4414">
                The right to access and receive a copy of your personal
                information
              </li>
              <li data-id="element-4415">The right to correct or update your personal information</li>
              <li data-id="element-4416">
                The right to request deletion of your personal information
              </li>
              <li data-id="element-4417">
                The right to restrict or object to processing of your personal
                information
              </li>
              <li data-id="element-4418">The right to data portability</li>
              <li data-id="element-4419">The right to withdraw consent</li>
            </ul>
            <p data-id="element-4420">
              To exercise these rights, please contact us using the information
              provided below.
            </p>
            <h3 data-id="element-4421">Changes to This Privacy Policy</h3>
            <p data-id="element-4422">
              We may update this Privacy Policy from time to time to reflect
              changes in our practices or legal requirements. We will post the
              updated Privacy Policy on this page and indicate the last updated
              date. We encourage you to review this Privacy Policy periodically.
            </p>
            <h3 data-id="element-4423">Contact Us</h3>
            <p data-id="element-4424">
              If you have any questions, concerns, or requests regarding this
              Privacy Policy or our privacy practices, please contact us at:
            </p>
            <p data-id="element-4425">
              Isonyin Grammar School
              <br data-id="element-4426" />
              Isonyin Road, Ijebu-Ode
              <br data-id="element-4427" />
              Ogun State, Nigeria
              <br data-id="element-4428" />
              Email:{' '}
              <a href="mailto:privacy@isonyingrammarschool.ng" data-id="element-4429">
                privacy@isonyingrammarschool.ng
              </a>
              <br data-id="element-4430" />
              Phone: +234 905 517 2703
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;